import { FullscreenContainer } from "@kalyzee/kast-web-sdk/web-components";
import React, { useState } from "react";

export const FullScreenRenderer: React.FC<{
  render: (enabled: boolean, setEnabled: (value: boolean) => void) => React.ReactNode;
}> = ({ render }) => {
  const [enabled, setEnabled] = useState(false);
  return (
    <FullscreenContainer
      style={{ width: "100%", height: "100%", minHeight: 0, minWidth: 0, display: "flex" }}
      fullscreen={enabled}
      onFullScreen={(value) => setEnabled(value)}
      useNative
    >
      <>{render(enabled, setEnabled)}</>
    </FullscreenContainer>
  );
};